// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e097337e","453":"077272f5","455":"87e10f87","977":"ed83d81b"}[chunkId] + ".chunk.js";
};